module.exports = __webpack_public_path__ + "media/country_flags/pm-30c6dda4.png";